import React from 'react';
import { Outlet } from 'react-router';
import { Link } from 'react-router-dom';

const RoomsMain = () => {

return (
    <>
    <div style={{ display: 'flex'}}>
        <div style={{ flex: "50%"}}>
            <p className='lead text-dark' style={{ padding: "1rem"}}>Rooms</p>
        </div>
        <div style={{ flex: "50%", paddingTop: "1rem"}}>
            <Link to='all'><button type="button" className="btn btn-outline-primary">All Rooms</button></Link>
            <Link to='vacant'><button type="button" className="btn btn-outline-warning">Vacant Rooms</button></Link>
            <Link to='add'><button type="button" className="btn btn-outline-success">Add Room</button></Link>
        </div>
    </div>
    <hr style={{padding: "0px"}}/>
    <Outlet />
    </>
)};

export default RoomsMain;